import {Component, ViewChild} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {Validators} from "@angular/forms";
import {StoreSelectorsService} from "../../../../services";
import {animate, state, style, transition, trigger} from '@angular/animations';
import {IBaseBlockComponent, ISceneItemNewValues} from "../../../../interfaces";
import {actionAddSceneItem, actionUpdateSceneItem} from "../../../../store/actions/user.actions";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {ButtonBarComponent, IButtonBar} from "../../../../components/add-remove-bar/button-bar.component";
import {ITablesSelector} from "../../../../components/tables-selector/tables-selector.component";
import {ToastrService} from "ngx-toastr";
import * as _ from "lodash";

@Component({
    selector: 'app-scene-block-rss',
    templateUrl: './block-rss.component.html',
    styleUrls: ['./block-rss.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class BlockRssComponent extends BlockBaseComponent implements IBaseBlockComponent {

    rssEmbeddedDataSource: Array<any> = [];
    showDescriptionFontSelector = true;
    displayedColumns: string[] = ['title', 'description'];
    highlightedRows = [];
    rssNames = [];
    defaultValue = '';
    defaultText = '[click to edit]';
    buttons: IButtonBar[] = [];
    rssLinks = {
        'https://feeds.nbcnews.com/feeds/topstories': 'US TopStories',
        'https://time.com/newsfeed/feed/': 'Time.com Top Stories',
        'https://feeds.nbcnews.com/feeds/worldnews': 'World News',
        'https://feeds.foxnews.com/foxnews/latest?format=xml': 'US General News',
        'https://www.newsweek.com/rss': 'General News',
        'https://globalnews.ca/canada/feed/': 'Canadian News',
        'https://feeds.feedburner.com/TheAustralianMediaNews': 'Australian News',
        'https://feeds.foxnews.com/foxnews/politics': 'US Politics',
        'https://globalnews.ca/politics/feed/': 'Canadian Politics',
        'https://www.standard.co.uk/news/politics/rss': 'UK Politics',
        'https://rss.nytimes.com/services/xml/rss/nyt/Business.xml': 'US Business',
        'https://www.canadianbusiness.com/feed/': 'Canadian Business',
        'https://feeds.bbci.co.uk/news/business/rss.xml': 'UK Business',
        'https://time.com/health/feed/': 'US Health',
        'https://www.thestar.com/feeds.articles.life.health_wellness.rss': 'Canadian Health',
        'https://feeds.bbci.co.uk/news/health/rss.xml': 'UK Health',
        'https://feeds.nbcnews.com/feeds/science': 'Science',
        'https://tech.yahoo.com/rss': 'Technology',
        'https://www.smithsonianmag.com/rss/science-nature/': 'Science and Nature',
        'https://rss.nytimes.com/services/xml/rss/nyt/Technology.xml': 'US Technology',
        'https://feeds.arstechnica.com/arstechnica/gadgets': 'Technology Gadgets',
        'https://sports.yahoo.com/rss': 'Sports now',
        'https://rss.nytimes.com/services/xml/rss/nyt/Sports.xml': 'US Sports',
        'https://www.si.com/rss/si_topstories.rss': 'SI Today',
        'https://www.sportsnet.ca/feed/': 'Canadian Sports',
        'https://feeds.bbci.co.uk/sport/0/rss.xml?edition=uk': 'UK Sports',
        'https://variety.com/feed/': 'US Entertainment',
        'https://www.tmz.com/rss.xml': 'US TMZ',
        'https://www.cbsnews.com/latest/rss/entertainment': 'CBS Entertainment',
        'https://feeds.nbcnews.com/feeds/todayentertainment': 'Entertainment Today',
        'https://news.yahoo.com/rss/world': 'World',
        'https://news.yahoo.com/rss/sports': ' Yahoo Sports',
        'https://news.yahoo.com/rss/us': 'U.S. National',
        'https://news.yahoo.com/rss/elections': 'Elections',
        'https://news.yahoo.com/rss/politics': 'Politics',
        'https://news.yahoo.com/rss/business': 'Business',
        'https://news.yahoo.com/rss/entertainment': 'Yahoo Entertainment',
        'https://news.yahoo.com/rss/health': 'Yahoo Health',
        'https://news.yahoo.com/rss/science': 'Science',
        'https://news.yahoo.com/rss/highestrated': 'Most Recommended',
        'https://feeds.fireside.fm/bibleinayear/rss': 'Bible in a Year',
        'https://rss.nytimes.com/services/xml/rss/nyt/Space.xml': 'Space and Beyond',
        'https://rss.nytimes.com/services/xml/rss/nyt/Science.xml': 'NYTimes Science',
        'https://rss.nytimes.com/services/xml/rss/nyt/Climate.xml': 'Climate and Environment',
        'https://rss.nytimes.com/services/xml/rss/nyt/Arts.xml': 'Art',
        'https://rss.nytimes.com/services/xml/rss/nyt/Movies.xml': 'Movies',
        'https://rss.nytimes.com/services/xml/rss/nyt/Music.xml': 'Music',
        'https://rss.nytimes.com/services/xml/rss/nyt/Theater.xml': 'Theater',
        'https://rss.nytimes.com/services/xml/rss/nyt/Television.xml': 'TV',
        'https://rss.nytimes.com/services/xml/rss/nyt/FashionandStyle.xml': 'Style and Fashion',
        'https://rss.nytimes.com/services/xml/rss/nyt/DiningandWine.xml': 'Wine and Dine',
        'https://rss.nytimes.com/services/xml/rss/nyt/Weddings.xml': 'Love and Weddings',
        'https://rss.nytimes.com/services/xml/rss/nyt/Travel.xml': 'Travel and Leisure',
        'https://rss.nytimes.com/services/xml/rss/nyt/Automobiles.xml': 'Cars, cars, cars',
        'https://rss.nytimes.com/services/xml/rss/nyt/MostViewed.xml': 'NY Times MostViewed',
        'https://content.api.nytimes.com/svc/news/v3/all/recent.rss': 'Latest News',
        'https://moxie.foxnews.com/google-publisher/us.xml': 'Foxnews US',
        'https://moxie.foxnews.com/google-publisher/world.xml': 'Foxnews World',
        'https://moxie.foxnews.com/google-publisher/sports.xml': 'Fox Sports',
        'https://moxie.foxnews.com/google-publisher/travel.xml': 'Travels',
        'https://moxie.foxnews.com/google-publisher/tech.xml': 'Fox Tech',
        'https://moxie.foxnews.com/google-publisher/health.xml': 'Health News',
        'https://moxie.foxnews.com/google-publisher/science.xml': 'Fox Science',
        'https://www.latimes.com/local/rss2.0.xml': 'LA Times',
        'https://www.politico.com/rss/politicopicks.xml': 'Politics',
        'https://cdn.feedcontrol.net/8/1114-wioSIX3uu8MEj.xml': 'Headlines',
        'http://www.ynet.co.il/Integration/StoryRss2.xml': 'ynet hebrew',
        custom: 'custom',
        embedded: 'embedded'
    };
    expandedRow;
    editRow = {
        title: '',
        description: ''
    };

    @ViewChild('dtable') dtable: any;

    @ViewChild(ButtonBarComponent) addRemoveBarComponent: ButtonBarComponent;

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog, private toastr: ToastrService) {
        super(storeSelector, dialog);

        this.buttons = [
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.add', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
            },

        ];
        this.initRssNames();
    }

    onAdd() {
        if (this.sceneItem.Data[0].EventCommands) {
            this.storeSelector.dispatch(actionAddSceneItem({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                values: [{
                    key: 'EventCommand',
                    value: {
                        $: {
                            from: "name",
                            command: "value"
                        }
                    },
                    storePath: `Data[0].EventCommands[0]`
                }]
            }));
        } else {
            this.dispatchSceneItemChanges({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                values: [{
                    key: 'EventCommands',
                    value: [{
                        "EventCommand": [
                            {
                                $: {
                                    from: "from",
                                    command: "command"
                                }
                            }
                        ]
                    }],
                    storePath: `Data[0]`
                }]
            });
        }
    }

    // onRemove() {
    //     if (this.highlightedRows.length === 0) return;
    //     const values: ISendEvents[] = [];
    //     this.highlightedRows.forEach((i_selected) => {
    //         this.rssEmbeddedDataSource.forEach((item, index) => {
    //             if (item === i_selected) {
    //                 // console.log('removing: name:' + item.name + ' index:' + index);
    //                 return;
    //             }
    //             values.push({
    //                 $: {
    //                     from: item.name,
    //                     command: item.command
    //                 }
    //             });
    //         });
    //     });
    //     this.dispatchChanges(values);
    // }

    inputEdited(index: number, field: ITablesSelector, value) {
        // console.log('edited index:' + index + ' value:' + this.dataSource[index].name + ' value:' + value);
        const values = [];
        this.rssEmbeddedDataSource.forEach((item, counter) => {
            values.push({
                $: {
                    from: counter === index ? value : item.name,
                    command: item.command
                }
            });
        });
        this.dispatchChanges(values);
    }

    onSelectedRow(row) {
        /** uncomment to support multi select **/
        /** this.highlightedRows.push(row) **/
        this.highlightedRows = [row];
        if (this.expandedRow !== row) {
            this.expandedRow = null;
        }
    }

    dispatchChanges(values) {
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'EventCommands',
                value: [{
                    EventCommand: values
                }],
                storePath: `Data[0]`
            }]
        });
    }

    private initRssNames() {
        Object.keys(this.rssLinks).forEach(field => {
            this.rssNames.push(this.rssLinks[field]);
        });
    }

    override submit(formValues) {
        return super.submit(formValues, (values: Array<ISceneItemNewValues>) => {
            let url = Object.keys(this.rssLinks).find((k) => this.rssLinks[k] === formValues.feed);
            const rssValue = this.sceneItem.Data[0]?.Rss?.[0]?.$?.url;
            const rssEmbedded = this.sceneItem?.Data?.[0]?.Rss?.[0]?.rss?.[0]?.channel?.[0]?.item;

            /** switching Store JSON structure to -> embedded RSS **/
            if (rssValue && url === 'embedded') {
                this.storeSelector.dispatch(actionUpdateSceneItem({
                        sceneId: this.sceneId,
                        sceneItemId: this.sceneItem.$.id,
                        values: [{
                            key: 'rss',
                            value: values,
                            storePath: 'Data[0].Rss[0]',
                            preProcessFunction: (sceneItemNewValues, draft, action, sceneTreeSlice) => {
                                const path = sceneTreeSlice.sceneItem?.Data?.[0]?.Rss?.[0]?.$;
                                delete path['url'];
                                delete path['minRefreshTime'];
                                const entry = {title: [this.defaultValue], description: [this.defaultValue]};
                                const newValue: any = [{channel: [{item: [entry]}]}];
                                const path2 = sceneTreeSlice.sceneItem?.Data?.[0]?.Rss?.[0];
                                path2.rss = newValue;
                                values.splice(values.findIndex((v) => v.key === 'url'), 1);
                                values.splice(values.findIndex((v) => v.key === 'minRefreshTime'), 1);
                            }
                        }]
                    })
                );
                this.storeSelector.dispatch({type: 'BREAK_MERGE'});
            }

            /** switching the Store JSON structure to -> default / non embedded RSS **/
            if (rssEmbedded && url !== 'embedded') {
                this.storeSelector.dispatch(actionUpdateSceneItem({
                        sceneId: this.sceneId,
                        sceneItemId: this.sceneItem.$.id,
                        values: [{
                            key: 'rss',
                            value: values,
                            storePath: 'Data[0].Rss[0]',
                            preProcessFunction: (sceneItemNewValues, draft, action, sceneTreeSlice) => {
                                const path = sceneTreeSlice.sceneItem?.Data?.[0]?.Rss?.[0];
                                delete path['rss'];
                                const path2 = sceneTreeSlice.sceneItem?.Data?.[0]?.Rss?.[0]?.$;
                                path2.url = '';
                                path2.minRefreshTime = '1';
                            }
                        }]
                    })
                );
                this.storeSelector.dispatch({type: 'BREAK_MERGE'});
            }

            switch (url) {
                case 'embedded': {
                    values.splice(values.findIndex((v) => v.key === 'url'), 1);
                    values.splice(values.findIndex((v) => v.key === 'minRefreshTime'), 1);
                    break;
                }

                case 'custom': {
                    url = formValues.url;
                    values[values.findIndex((v) => v.key === 'url')].value = url;
                    break;
                }

                default: {
                    values[values.findIndex((v) => v.key === 'url')].value = url;
                    break;
                }
            }
            return values;
        });
    }

    onEmbeddedAdded(event) {
        const values: Array<any> = this.sceneItem?.Data?.[0]?.Rss[0]?.rss?.[0]?.channel?.[0]?.item;
        const newValues = _.cloneDeep(values);
        newValues.push({title: [this.defaultValue], description: [this.defaultValue]});
        const changes = [];
        changes.push({
            key: 'item',
            value: [...newValues],
            storePath: 'Data[0].Rss[0].rss[0].channel[0]'
        });
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: changes
        });
        this.highlightedRows = [];
    }

    // onEmbeddedUpdated(member, index, newValue) {
    //     const values: Array<any> = this.sceneItem?.Data?.[0]?.Rss[0]?.rss?.[0]?.channel?.[0]?.item;
    //     const newValues = _.cloneDeep(values);
    //     const newItem = _.cloneDeep(item);
    //     newItem[member][0] = _.isEmpty(newValue.trim()) ? this.defaultValue : newValue;
    //     newValues[index] = newItem;
    //     this.dispatchSceneItemChanges({
    //         sceneId: this.sceneId,
    //         sceneItemId: this.sceneItem.$.id,
    //         values: [{key: 'item', value: newValues, storePath: 'Data[0].Rss[0].rss[0].channel[0]'}]
    //     });
    // }

    onEmbeddedRemoved(event) {
        const value = this.highlightedRows[0];
        const values: Array<any> = this.sceneItem?.Data?.[0]?.Rss[0]?.rss?.[0]?.channel?.[0]?.item;
        if (values.length === 1)
            return this.toastr.error(this.translocoService.translate('toast.atleastOneItem', {}, this.translocoService.getActiveLang()));
        const newValues = _.cloneDeep(values);
        newValues.splice(newValues.findIndex((item) => value.title[0] === item.title[0] && value.description[0] === item.description[0]), 1);
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{key: 'item', value: newValues, storePath: 'Data[0].Rss[0].rss[0].channel[0]'}]
        });
        this.highlightedRows = [];
    }

    onEmbeddedUpdated(index, member = null, newValue = null) {
        if (!member) {
            this.expandedRow = null;
        }

        const values: Array<any> = this.sceneItem?.Data?.[0]?.Rss[0]?.rss?.[0]?.channel?.[0]?.item;
        const newValues = _.cloneDeep(values);

        const newTitle = this.editRow.title;
        const newDescription = this.editRow.description;

        const newItem = {
            title: [_.isEmpty(newTitle.trim()) ? this.defaultValue : newTitle],
            description: [_.isEmpty(newDescription.trim()) ? this.defaultValue : newDescription]
        };

        if (member) {
            newItem[member][0] = _.isEmpty(newValue.trim()) ? this.defaultValue : newValue;
        }
        newValues[index] = newItem;
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{key: 'item', value: newValues, storePath: 'Data[0].Rss[0].rss[0].channel[0]'}]
        });
    }

    onExpandRow(row) {
        this.expandedRow = this.expandedRow === row ? null : row;
        if (this.expandedRow) {
            this.editRow.title = this.expandedRow.title[0];
            this.editRow.description = this.expandedRow.description[0];
        } else {
            this.editRow.title = this.defaultValue;
            this.editRow.description = this.defaultValue;
        }
    }

    override componentInit() {
        super.componentInit();
        const rssValue = this.sceneItem?.Data?.[0]?.Rss?.[0]?.$?.url;
        const rssEmbedded = this.sceneItem?.Data?.[0]?.Rss[0]?.rss?.[0]?.channel?.[0]?.item;
        if (rssEmbedded) {
            this.rssEmbeddedDataSource = rssEmbedded;
            this.setUiConfigValue('url', 'none');
            this.setUiConfigValue('minRefreshTime', '0');
            this.setUiConfigValue('feed', 'embedded');
        } else {
            this.rssEmbeddedDataSource = [];
            const foundRssName = this.rssLinks[rssValue];
            foundRssName === undefined ? this.setUiConfigValue('feed', 'custom') : this.setUiConfigValue('feed', foundRssName);
        }
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        this.toggleDirection();
        const rssValue = this.sceneItem?.Data?.[0]?.Rss?.[0]?.$?.url;
        const rssEmbedded = this.sceneItem?.Data?.[0]?.Rss[0]?.rss?.[0]?.channel?.[0]?.item;
        if (rssEmbedded) {
            this.rssEmbeddedDataSource = rssEmbedded;
        } else {
            this.rssEmbeddedDataSource = [];
            this.setFormValue('url', rssValue);
        }
    }

    toggleDirection() {
        const vertical = this.sceneItem?.Data?.[0]?.Rss[0].$.vertical;
        if (vertical) {
            this.showDescriptionFontSelector = vertical === '1';
        }
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "select",
                label: this.translocoService.translate('general.feed', {}, this.translocoService.getActiveLang()),
                name: "feed",
                value: "Tech",
                options: this.rssNames
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.url', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "url",
                storePath: 'Data[0].Rss[0].$.url'
            },
            {
                type: "radiobutton",
                label: this.translocoService.translate('general.direction', {}, this.translocoService.getActiveLang()),
                name: "vertical",
                options: ["horizontal", "vertical"],
                value: "horizon",
                storePath: 'Data[0].Rss[0].$.vertical'
            },
            {
                type: "radiobutton",
                label: this.translocoService.translate('general.textDirection', {}, this.translocoService.getActiveLang()),
                name: "rtl",
                options: ["LTR", "RTL"],
                value: "RTL",
                storePath: 'Data[0].Rss[0].$.rtl'
            },
            {
                type: "input",
                value: '1',
                label: this.translocoService.translate('general.speed', {}, this.translocoService.getActiveLang()),
                min: '1',
                max: '999',
                inputType: "number",
                name: "speed",
                storePath: 'Data[0].Rss[0].$.speed',
                validations: [
                    {
                        name: "required",
                        validator: Validators.required,
                        message: "value required"
                    },
                    {
                        name: "pattern",
                        validator: Validators.pattern("^[0-9]+$"),
                        message: "Accept only numbers"
                    }
                ]
            },
            {
                type: "input",
                value: '30',
                label: this.translocoService.translate('general.requestDataMinutes', {}, this.translocoService.getActiveLang()),
                min: '2',
                max: '1440',
                step: '1',
                inputType: "number",
                name: "minRefreshTime",
                storePath: 'Data[0].Rss[0].$.minRefreshTime',
                validations: [
                    {
                        name: "required",
                        validator: Validators.required,
                        message: "value required"
                    },
                    {
                        name: "pattern",
                        validator: Validators.pattern(/^\d*\.?\d*$/),
                        // validator: Validators.pattern("^[a-zA-Z]+$"),
                        message: "Accept only numbers"
                    }
                ]
            },
            // {
            //     type: "input",
            //     label: '',
            //     inputType: 'tablelist',
            //     tableColumns: this.tableColumns,
            //     ignoreMissingValue: true,
            //     cloneVals: true,
            //     multiSelect: false,
            //     rememberSelection: false,
            //     allowFilter: true,
            //     buttonBarClassName: 'rssButtonBar',
            //     buttons: this.buttons,
            //     inputEditFormat: {title: 'text', description: 'text'},
            //     requiredFields: {title: true, description: false},
            //     inputEditRenamePath: [{path: 'title', key: 'title'}, {path: 'description', key: 'description'}],
            //     name: "Page",
            //     storePath: 'Data[0].Rss[0].rss[0].channel[0].item',
            //     expandableEditor: true,
            //     callBackEvent: (v) => this.onTableListChangeCallBack(v)
            //     // callBackFaIcon: (v) => BlockPlaylistComponent.onCallBackFaIcon(v),
            // }
            // ,{
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //     name: "gpu",
            //     storePath: '$.gpu'
            // }
            // {
            //   type: "input",
            //   value: "born2net@gmail.com",
            //   label: "Email Address",
            //   inputType: "email",
            //   name: "email",
            //   validations: [
            //     {
            //       name: "required",
            //       validator: Validators.required,
            //       message: "Email Required"
            //     },
            //     {
            //       name: "pattern",
            //       validator: Validators.pattern(
            //         "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$"
            //       ),
            //       message: "Invalid email"
            //     }
            //   ]
            // },
            // {
            //   type: "input",
            //   value: '123123',
            //   label: "Password",
            //   inputType: "password",
            //   name: "password",
            //   validations: [
            //     {
            //       name: "required",
            //       validator: Validators.required,
            //       message: "Password Required"
            //     }
            //   ]
            // },
            // {
            //   type: "date",
            //   value: '2019-08-06',
            //   label: "DOB",
            //   name: "dob",
            //   validations: [
            //     {
            //       name: "required",
            //       validator: Validators.required,
            //       message: "Date of Birth Required"
            //     }
            //   ]
            // },
            // {
            //   type: "checkbox",
            //   label: "Accept Terms",
            //   name: "term",
            //   value: true
            // },
            // {
            //   type: "button",
            //   label: "Save"
            // }
        ];
    }

    onTableListChangeCallBack(e) {

    }
}

